// The combined config for you environment will be available in the CONFIG global in your Javascript
module.exports = {
  supportTicketApi: 'https://ticket.prohub.dev-godaddy.com/api/v1/tickets',
  godaddyProDomain: 'pro.dev-godaddy.com',
  optinApi: 'https://optin.pcx.dev-godaddy.com/api',
  optOutRedirect: 'https://account.dev-godaddy.com/products?go_redirect=disabled&pro_opt_out=true',
  proApi: 'https://api.prohub.dev-godaddy.com/api/v1',
  hubUrl: 'https://hub.dev-godaddy.com',
  expertsApi: 'https://api.experts.dev-godaddy.com/v1'
};
